<section class="bg-half-260 bg-primary d-table w-100" id="home"
         style="background-size:cover; background-image:url('assets/3r/cover/people-2557396_640.jpg');">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-heading text-center mt-4">
                    <h1 class="display-4 title-dark font-weight-bold text-white mb-3">CAREER COUNSELLING</h1>
                    <!--                    <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>-->
                    <!--                    <div class="mt-4 pt-2">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-primary"><i class="mdi mdi-email"></i> Get-->
                    <!--                            Started</a>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

</section>

<div class="container mt-100 mt-60 mb-5">
    <div class="row ">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h3 class="title mb-4 mt">EDUCATION AND CAREER COUNSELLORS</h3>
                <p class="text-muted   mb-0">
                    We offer the best education and career counseling services to students absolutely free! 3R International offers expert career counselling guidance to make your dream of obtaining an
                    international world class qualification to grow faster in your career. We will not only help you to choose the correct course, college and country but also advice you on your career goals in the
                    industry. You need to know the facts about study abroad and the best options within your budget. Not just any sales pitch from vested interests. One wrong decision and it will impact you for the rest
                    of your life. So choose carefully.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>
    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">3R INTERNATIONAL WILL HELP YOU WITH</h5>
                <p class="text-muted   mb-0">
                    ✤ Unbiased, expert counseling to get admission into the best as per your profile <br>
                    ✤ Applications & Admissions – meeting deadlines <br>
                    ✤ Visa filing, interview preparation – to get the student visa <br>
                    ✤ Accommodation & Arrival services – to make your transition smooth for a new beginning <br>
                    ✤ Career Guidance – to ensure your investment bears fruit <br>
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">CHOOSE THE CORRECT COLLEGE</h5>
                <p class="text-muted   mb-0">
                    Ranking does matter. If you can afford it, go to the best. Just like you choose the best software
                    company to work in, choose the best college as per your budget. With hundreds of colleges to choose
                    from you can get confused. How do you rank the colleges? Choose college wisely – see what is your
                    requirement and your pocket.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">WHY CHOOSE OUR CAREER COUNSELLING CONSULTANTS??</h5>
                <p class="text-muted   mb-0">
                    ✤ Comprehensive Career and International education counseling for students <br>
                    ✤ Unprejudiced, Free and Honest advice on the courses available in different universities <br>
                    ✤ Awareness and education counseling sessions and seminars with professional education counselors in Sri Lanka <br>
                    ✤  Pre-Visa applications Guidance and constant follow-ups <br>
                    ✤ Guidance on settlement of fees with the Institution <br>
                    ✤ Guidance on study abroad scholarships, their availability and criteria <br>
                    ✤ Guidance on future Prospects of the students’ chosen career paths <br>
                    ✤ Accommodation & Travel arrangements <br>
                    ✤ Pre-Departure counseling and guidance <br>
                    <br>
                    Our team of overseas education consultants is trained to offer students the best advice and assistance keeping in mind their aptitude, budget, and country preferences.
                    All you have to do is to give us a call or drop into our office and together we will find the best International education opportunities for you.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>


</div>
